import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { noRowsTemplate } from "@/components/GiftsPage/noRowsTemplate";
import { referralNoRowsTemplate } from "@/components/ReferralPage/noRowsTemplate";
import { ReferralServices } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import symbolInTable from "@/components/WalletPage/SymbolInTable/index.vue";
import PricesInTable from "@/components/GiftsPage/PricesInTable";
import dayjs from "@/utiles/dayjs";
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "gifts-page",
  components: { AgGridVue, symbolInTable, PricesInTable },
  props: [],
  mixins: [$thousandMask],
  data() {
    return {
      copyReferralCode: true,
      referralInfoBox: null,
      referralCardLoader: true,
      referralTableLoader: true,
      loading: false,
      invitedTableHeader: null,
      defaultInvitedHeader: null,
      invitedData: null,
      giftTableLoader: true,
      giftsLoading: false,
      giftsTableHeader: null,
      defaultGiftsHeader: null,
      giftsData: null,
      information: null,
      filterModal: false,
      page: 1,
      giftsPage: 1,
      gridOptions: null,
      gridOptionsGifts: null,
      localeText: null,
      paginationPageSize: 10,
      paginationNumberFormatter: null,
      tableItemShow: [
        { name: "10", value: 10 },
        { name: "20", value: 20 },
        { name: "30", value: 30 }
      ],
      tableItemShowFirstIndex: 10
    };
  },
  beforeMount() {
    this.localeText = {
      to: this.$t("giftsPage.to"),
      of: this.$t("giftsPage.from")
    };
    this.giftsTableHeader = [
      // {
      //   colId: 0,
      //   headerName: this.$t("giftsPage.symbol"),
      //   field: "symbol",
      //   cellRendererFramework: "symbolInTable",
      //   headerClass: "update-cell-symbol header-table-ag-grid-cell",
      //   pinned:
      //     this.$vuetify.breakpoint.mobile || this.$vuetify.breakpoint.sm
      //       ? "right"
      //       : "",
      //   suppressSizeToFit: true,
      //   flex: 1,
      //   minWidth: 100,
      //   maxWidth: 100
      // },
      {
        colId: 0,
        headerName: this.$t("giftsPage.rowNumber"),
        field: "row_number",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 100,
        maxWidth: 100
      },
      {
        colId: 1,
        headerName: this.$t("giftsPage.description"),
        field: "user_description",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 2,
        minWidth: 300
      },
      {
        colId: 2,
        headerName: this.$t("giftsPage.symbol"),
        field: "symbol",
        cellRendererFramework: "symbolInTable",
        headerClass: "update-cell-symbol header-table-ag-grid-cell",
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 100
      },
      {
        colId: 3,
        headerName: this.$t("giftsPage.amount"),
        field: "amount",
        // cellRendererFramework: "PricesInTable",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 150,
        cellRenderer: params => {
          return params.value != 0 ? params.value : "-";
        }
      },
      {
        colId: 4,
        headerName: this.$t("giftsPage.BCEQ"),
        field: "BCEQ",
        unSortIcon: true,
        cellRenderer: params => {
          return params.value != 0 ? "USDT " + params.value : "-";
        },
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 180
      },
      {
        colId: 5,
        headerName: this.$t("giftsPage.invited"),
        field: "referral_code",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 120
      },
      {
        colId: 6,
        headerName: this.$t("giftsPage.transactionId"),
        field: "ref_no",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 170
      },
      {
        colId: 7,
        headerName: this.$t("giftsPage.date"),
        field: "created_at",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 170,
        maxWidth: 170
      }
    ];
    this.defaultGiftsHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      suppressSizeToFit: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.gridOptions = {
      overlayNoRowsTemplate: referralNoRowsTemplate(
        this.$t("referral.noInviteMsg")
      )
    };
    this.gridOptionsGifts = {
      overlayNoRowsTemplate: noRowsTemplate.template
    };
    this.invitedTableHeader = [
      {
        colId: 0,
        headerName: this.$t("giftsPage.rowNumber"),
        field: "row_number",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 100
      },
      {
        colId: 1,
        headerName: this.$t("giftsPage.invited"),
        field: "referral_code",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 120
      },
      {
        colId: 2,
        headerName: this.$t("giftsPage.totalBCEQ"),
        field: "total_BCEQ",
        cellRenderer: params => {
          return params.value != 0 ? "USDT " + params.value : "-";
        },
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 200
      },
      {
        colId: 3,
        headerName: this.$t("giftsPage.registerDate"),
        field: "created_at",
        unSortIcon: true,
        suppressSizeToFit: true,
        flex: 1,
        minWidth: 170,
        maxWidth: 170,
        cellClass: "ag-grid-date-class"
      }
    ];
    this.defaultInvitedHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      suppressSizeToFit: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    setInvitedData() {
      let data = [];
      if (this.invitedData) {
        this.invitedData.data?.forEach((elem, index) => {
          data.push({
            row_number: index + 1,
            total_BCEQ: this.$thousandMask(elem.totalBCEQ),
            referral_code: elem.referredCode,
            created_at:
              dayjs(elem.createdAt).format("mm : HH") +
              " - " +
              dayjs(elem.createdAt).format("YYYY/MM/DD")
          });
        });
      }
      return data;
    },
    setGiftsData() {
      let data = [];
      if (this.giftsData) {
        this.giftsData.data?.forEach((elem, index) => {
          data.push({
            row_number: index + 1,
            id: elem.id,
            symbol: { logo: elem.currency.logo, iso: elem.currency.iso },
            referral_code: elem.referredCode,
            ref_no: elem.trackingCode,
            BCEQ: this.$thousandMask(elem.BCEQ),
            amount: this.$thousandMask(elem.amount),
            created_at:
              dayjs(elem.createdAt).format("mm : HH") +
              " - " +
              dayjs(elem.createdAt).format("YYYY/MM/DD"),
            user_description: elem.description
          });
        });
      }
      return data;
    }
  },
  mounted() {
    this.getInvitation();
    // this.getGifts();
    this.getInformation();
    this.getPage();
  },
  methods: {
    test() {
      this.gridApi.sizeColumnsToFit();
    },
    referralCopy() {
      if (this.copyReferralCode) {
        this.copyReferralCode = false;
        this.$toast.success(this.$t("referral.invitationCodeCopied"));
      } else {
        setTimeout(() => {
          this.copyReferralCode = true;
        }, 3000);
      }
    },
    copyLink() {
      this.$toast.success(this.$t("referral.invitationLinkCopied"));
    },
    getGifts() {
      this.giftsLoading = true;
      ReferralServices.getGifts()
        .then(response => {
          this.giftTableLoader = false;
          this.giftsData = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.giftsLoading = false;
        });
    },
    getPage() {
      ReferralServices.getPage().then(response => {
        this.referralInfoBox = response.data.data;
      });
    },
    getInformation() {
      ReferralServices.getInformation().then(res => {
        this.information = res.data.data;
        this.referralCardLoader = false;
      });
    },
    getInvitation() {
      this.loading = true;
      ReferralServices.getInvitation()
        .then(response => {
          this.referralTableLoader = false;
          this.invitedData = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getInvitedPerPage(page) {
      this.loading = true;
      this.invitedData = [];
      ReferralServices.getInvitedPagination(page)
        .then(response => {
          this.invitedData = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getGiftsPerPage(page) {
      this.giftsLoading = true;
      this.giftsData = [];
      ReferralServices.getGiftsPagination(page)
        .then(response => {
          this.giftsData = response.data;
        })
        .catch(() => {})
        .finally(() => {
          this.giftsLoading = false;
        });
    },
    onPageSizeChanged(item, name) {
      this.gridApi.paginationSetPageSize(Number(item));
      this.tableItemShowFirstIndex = name;
    }
  }
};
